import { AfterContentInit, Component, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Appareil } from 'src/app/domain/Qualif/appareil';
import { ETypeAppareil } from 'src/app/domain/Qualif/enums/type-appareil';
import { UserService } from 'src/app/services/user.service';
import { CoreData } from 'src/app/tools/core-data/core-data';
import { PreventDoubleClickDirective } from 'src/app/tools/directive/prevent-double-click.directive';
import { AppareilBoxDialog } from 'src/app/tools/ui/appareil-box/appareil-box';
import { NotificationManager } from 'src/app/tools/ui/notification-manager';
import * as _ from 'lodash'
import { StringConverter } from 'src/app/tools/ui/string-converter';
import { EMarqueAppareilAir } from 'src/app/domain/Qualif/enums/marque-appareil-air';
import { EMarqueCompteur } from 'src/app/domain/Qualif/enums/marque-compteur';
import { EMarqueMultimetre } from 'src/app/domain/Qualif/enums/marque-multimetre';
import { EMarqueAppareilSurface } from 'src/app/domain/Qualif/enums/marque-appareil-surface';
import { EModeleMultimetre } from 'src/app/domain/Qualif/enums/modele-multimetre';
import { EModeleCompteur } from 'src/app/domain/Qualif/enums/modele-compteur';
import { EModeleAppareilSurface } from 'src/app/domain/Qualif/enums/modele-appareil-surface';
import { EModeleAppareilAir } from 'src/app/domain/Qualif/enums/modele-appareil-air';

@Component({
    selector: 'app-appareils',
    standalone: true,
    imports: [MatButtonModule, MatIconModule, PreventDoubleClickDirective],
    templateUrl: './appareils.component.html',
    styleUrl: './appareils.component.scss'
})
export class AppareilsComponent implements OnInit, AfterContentInit {
    AppareilList: Appareil[] = [];

    constructor(
        private userService: UserService,
        private coreData: CoreData,
        private snackBar: MatSnackBar,
        private dialog: MatDialog,
    ) { }
    ngOnInit(): void {

    }

    ngAfterContentInit(): void {
        this.getUserInformation();
    }

    hasBiocollecteur() {
        return this.AppareilList.find(x => x.Type === ETypeAppareil.Biocollecteur || x.Type === ETypeAppareil.Biocollecteur2)
    }

    hasMultimetre() {
        return this.AppareilList.find(x => x.Type === ETypeAppareil.Multimetre)
    }

    hasCompteur() {
        return this.AppareilList.find(x => x.Type === ETypeAppareil.Compteur)
    }

    hasApplicateurContact() {
        return this.AppareilList.find(x => x.Type === ETypeAppareil.ApplicateurContact)
    }

    getAppareilType(app: Appareil) {
        return StringConverter.getTypeAppareilLabel(app.Type);
    }

    getBrandLabel(app: Appareil) {

        switch (app.Type) {
            case ETypeAppareil.Biocollecteur:
            case ETypeAppareil.Biocollecteur2:
                return StringConverter.getMarqueAppareilAirLabel(app.Marque as EMarqueAppareilAir)
            case ETypeAppareil.ApplicateurContact:
                return StringConverter.getMarqueAppareilSurfaceLabel(app.Marque as EMarqueAppareilSurface)
            case ETypeAppareil.Compteur:
                return StringConverter.getMarqueCompteurLabel(app.Marque as EMarqueCompteur)
            case ETypeAppareil.Multimetre:
                return StringConverter.getMarqueMultimetreLabel(app.Marque as EMarqueMultimetre)
            default:
                return '';
        }
    }

    getModelLabel(app: Appareil) {

        switch (app.Type) {
            case ETypeAppareil.Biocollecteur:
            case ETypeAppareil.Biocollecteur2:
                return StringConverter.getModeleAppareilAirLabel(app.Modele as EModeleAppareilAir)
            case ETypeAppareil.ApplicateurContact:
                return StringConverter.getModeleAppareilSurfaceLabel(app.Modele as EModeleAppareilSurface)
            case ETypeAppareil.Compteur:
                return StringConverter.getModeleCompteurLabel(app.Modele as EModeleCompteur)
            case ETypeAppareil.Multimetre:
                return StringConverter.getModeleMultimetreLabel(app.Modele as EModeleMultimetre)
            default:
                return '';
        }
    }

    getUserInformation() {
        this.userService.getUserByEmail(this.coreData.User?.Email!).subscribe(async x => {
            if (x) {
                this.AppareilList = x.AppareilQualifList;
            }
        });
    }

    save() {
        this.userService.updateAppareilList(this.coreData.User?.Email!, this.AppareilList).subscribe(x => {
            if (x) {
                this.getUserInformation();
                NotificationManager.handleSuccess('Appareil ajouté', this.snackBar);
            }
        })
    }

    deleteAppareil(app: Appareil) {
        _.remove(this.AppareilList, x => x.NumeroInterne === app.NumeroInterne)
        this.save();
    }

    openAppareil(appareil?: Appareil) {
        const dialogRef = this.dialog.open(AppareilBoxDialog, {
            data: {
                appareil: appareil,
                alreadyPicked: this.AppareilList
            },
            width: '777px',
            disableClose: true
        });

        dialogRef.afterClosed().subscribe(async (result: Appareil) => {
            if (result) {
                // await this.appareilRepository.updateAppareil(result)
                if (appareil) {
                    appareil = result
                } else {
                    this.AppareilList.push(result);
                }

                this.save();
            }
        });
    }
}
